<template>
  <v-row class="ma-0">
    <v-btn
      v-if="product.InfoVideo != null && product.InfoVideo.trim() !== ''"
      text
      outlined
      color="primary"
      class="mr-3 mb-2 text-capitalize"
      @click="showVideo"
    >
      {{ $translate('SHOW_VIDEO') }}
      <v-icon right>mdi-youtube</v-icon>
    </v-btn>
    <v-btn
      v-if="product.PreparationInstruction != null
        && product.PreparationInstruction.trim() !== ''"
      text
      outlined
      color="primary"
      class="mr-3 mb-2 text-capitalize"
      @click="showInstructionDialog = true"
    >
      {{ $translate('PREPARATION_INSTRUCTION_BTN') }}
      <v-icon right>mdi-information</v-icon>
    </v-btn>

    <!-- Dialog to show preparation instruction -->
    <ConfirmDialog
      :visible="showInstructionDialog"
      :title="$translate('PREPARATION_INSTRUCTION_TITLE')"
      :message="getPreparationInstruction()"
      :positiveBtnText="$translate('CLOSE')"
      @positiveBtnClicked="showInstructionDialog = false"
    ></ConfirmDialog>
  </v-row>
</template>

<script>
import utility from '@/shared/utility';
import ConfirmDialog from '@/components/generalComponents/uiComponents/ConfirmDialog';

export default {
  name: 'ProductInfoButtons',
  components: {
    ConfirmDialog,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showInstructionDialog: false,
    };
  },
  computed: {},
  methods: {
    showVideo() {
      const fullUrl = utility.getFullUrl(this.product.InfoVideo);
      window.open(fullUrl);
    },
    getPreparationInstruction() {
      return utility.lineBreaksToHtml(this.product.PreparationInstruction);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
